const getDefaultBulkWarnings = (entityLabel = 'items', { deleteAllSelected = false } = {}) => ({
  delete: {
    header: `Deleting ${entityLabel} is permanent.`,
    subtext: deleteAllSelected
      ? `Selected ${entityLabel} will be permanently deleted.`
      : `Only archived ${entityLabel} will be deleted.`,
  },
  archive: {
    header: `Archiving ${entityLabel} will hide them from active lists.`,
  },
  activate: {
    header: `Activating ${entityLabel} will restore them to active lists.`,
  },
});

export const resolveBulkWarning = ({
  action,
  entityLabel = 'items',
  deleteAllSelected = false,
  warnings = {},
} = {}) => {
  if (!action) return {};
  const defaults = getDefaultBulkWarnings(entityLabel, { deleteAllSelected });
  return {
    ...defaults[action],
    ...warnings[action],
  };
};
